import Box from "@mui/material/Box"
import { createFileRoute } from "@tanstack/react-router"
import { uomLoader } from "shared/loaders"
import { z } from "zod"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { CheckedInGoodsReceiptDetailsLayout } from "@/screens/WarehouseReceiving/subfeatures/CheckedIn/components"

const searchSchema = z.object({
  showSuccessDialog: z.boolean().optional(),
})

export const Route = createFileRoute("/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout")({
  validateSearch: searchSchema,
  loader: uomLoader,
  component: () => (
    <Box className='flex size-full flex-col'>
      <PermissionContentWrapper permissions={[PermissionActionType.WAREHOUSE_RECEIVING_VIEW]}>
        <CheckedInGoodsReceiptDetailsLayout />
      </PermissionContentWrapper>
    </Box>
  ),
})
